// Rank-b2b.jsx
import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Grid, Image, Stepper, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import BadgeSVG from '../../assets/images/dashboard/badge.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

const Rank = ({ props }) => {

    const [isCurrent, setIsCurrent] = React.useState([false, false, false, false, false]);
    const [nightReservesCount, setNightReservesCount] = React.useState(0);
    const [totalReservesPrice, setTotalReservesPrice] = React.useState(0);
    const [userPlanDetails, setUserPlanDetails] = React.useState('loading');

    React.useEffect(() => {
        if (props.userPlanDetails.status === 200) {
            setUserPlanDetails(props.userPlanDetails.data);
        }
        if (props.nightReservesCount.status === 200) {
            setNightReservesCount(props.nightReservesCount.data);
        }
        if (props.totalReservesPrice.status === 200) {
            setTotalReservesPrice(props.totalReservesPrice.data);
        }
        if (userPlanDetails !== 'loading' && nightReservesCount !== 0) {
            userPlanDetails.forEach((obj, index) => {
                if (Math.ceil(obj.MinValue) <= nightReservesCount) {
                    if (index === 0) {
                        setIsCurrent(['active', false, false, false, false]);
                    } else if (index === 1) {
                        setIsCurrent(['active', 'active', false, false, false]);
                    } else if (index === 2) {
                        setIsCurrent(['active', 'active', 'active', false, false]);
                    } else if (index === 3) {
                        setIsCurrent(['active', 'active', 'active', 'active', false]);
                    } else if (index === 4) {
                        setIsCurrent(['active', 'active', 'active', 'active', 'active']);
                    }
                }
            });
        }
    }, [props, nightReservesCount, userPlanDetails]);

    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper
                    className={`bg-white rounded-lg border-solid border-light`}>
                    <Box
                        className={`d-flex align-item-center w-100 px-lg`}
                        ms={{
                            height: '62px'
                        }}>
                        <Typography
                            className={`w-100`}
                            component='h4'
                            ms={{
                                fontWeight: 'normal !important'
                            }}>
                            سطح فعلی شما
                        </Typography>
                    </Box>  
                    <Box
                        className={`mx-auto divider-horizontal divider-light`}
                        ms={{
                            width: '95%'
                        }} />
                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                        <React.Fragment>
                            <Grid.Item
                                size='col-12'>
                                <Image
                                    className={`mx-auto`}
                                    src={BadgeSVG}
                                    alt='rank'
                                    ms={{
                                        width: '82px',
                                        height: 'auto'
                                    }} />
                                <Box
                                    className={`my-sm`} />
                                <Box
                                    className={`text-center`}>
                                    <Typography
                                        className={`text-center`}>
                                        شما در سطح  
                                    </Typography> <Typography
                                        className={`text-primary`}>
                                        {userPlanDetails !== 'loading' && userPlanDetails.map((obj, index) => (
                                            <React.Fragment key={index}>
                                                {obj.IsCurrent && (
                                                    <Typography className={`text-primary`} component='span'>
                                                        {obj.Title}
                                                    </Typography>
                                                )}
                                            </React.Fragment>
                                        ))} {userPlanDetails === 'loading' &&
                                            <Image
                                                className={`d-inline`}
                                                src={LoadingCustomSVG}
                                                ms={{
                                                    width: '20px',
                                                    height: '20px'
                                                }} />
                                        }
                                    </Typography> <Typography>
                                        قرار دارید.
                                    </Typography>
                                </Box>
                            </Grid.Item>
                            <Box
                                className={`mx-auto my-sm mb-0 divider-horizontal divider-light`}
                                ms={{
                                    width: '50%'
                                }} />
                            <Grid.Item
                                size='col-12'>
                                <Box
                                    className={`p-lg`}>
                                    <Box
                                        className={`d-flex justify-content-between`}>
                                        <Typography>
                                            مجموع کل رزروهای شما
                                        </Typography>
                                        <Typography component='small'>
                                            {nightReservesCount !== 0 &&
                                                <React.Fragment>
                                                    {(Math.floor(totalReservesPrice) / 10).toLocaleString()} تومان
                                                </React.Fragment>
                                            }
                                            {nightReservesCount === 0 &&
                                                <Image
                                                    className={`d-inline`}
                                                    src={LoadingCustomSVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            }
                                        </Typography>
                                    </Box>
                                    <Box
                                        className={`my-xl`} />
                                    <Stepper>
                                        <Stepper.Item active={isCurrent[0]}>
                                            <Typography component='small' className={isCurrent[0] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[0] === false ? { color: '#6F6F7E' } : {}}>
                                                {userPlanDetails !== 'loading' && userPlanDetails[0]?.Title}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                            <Typography component='small'>
                                                {userPlanDetails !== 'loading' && `${userPlanDetails[0]?.MinValue / 10000000} میلیون`}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                        </Stepper.Item>
                                        <Stepper.Item active={isCurrent[1]}>
                                            <Typography component='small' className={isCurrent[1] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[1] === false ? { color: '#6F6F7E' } : {}}>
                                                {userPlanDetails !== 'loading' && userPlanDetails[1]?.Title}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                            <Typography component='small'>
                                                {userPlanDetails !== 'loading' && `${userPlanDetails[1]?.MinValue / 10000000} میلیون`}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                        </Stepper.Item>
                                        <Stepper.Item active={isCurrent[2]}>
                                            <Typography component='small' className={isCurrent[2] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[2] === false ? { color: '#6F6F7E' } : {}}>
                                                {userPlanDetails !== 'loading' && userPlanDetails[2]?.Title}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                            <Typography component='small'>
                                                {userPlanDetails !== 'loading' && `${userPlanDetails[2]?.MinValue / 10000000} میلیون`}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                        </Stepper.Item>
                                        <Stepper.Item active={isCurrent[3]}>
                                            <Typography component='small' className={isCurrent[3] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[3] === false ? { color: '#6F6F7E' } : {}}>
                                                {userPlanDetails !== 'loading' && userPlanDetails[3]?.Title}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                            <Typography component='small'>
                                                {userPlanDetails !== 'loading' && `${userPlanDetails[3]?.MinValue / 10000000} میلیون`}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                        </Stepper.Item>
                                        <Stepper.Item active={isCurrent[4]}>
                                            <Typography component='small' className={isCurrent[4] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[4] === false ? { color: '#6F6F7E' } : {}}>
                                                {userPlanDetails !== 'loading' && userPlanDetails[4]?.Title}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                            <Typography component='small'>
                                                {userPlanDetails !== 'loading' && `${userPlanDetails[4]?.MinValue / 10000000} میلیون`}
                                                {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                            </Typography>
                                        </Stepper.Item>
                                    </Stepper>
                                </Box>
                            </Grid.Item>
                        </React.Fragment>
                    }
                    {scale === 'x-small' &&
                        <React.Fragment>
                            <Grid.Item
                                size='col-8'
                                className={`align-self-center`}>
                                <Typography className={`p-sm`}>
                                    شما در سطح   {userPlanDetails !== 'loading' && userPlanDetails.map((obj, index) => (
                                        <React.Fragment key={index}>
                                            {obj.IsCurrent && (
                                                <Typography className={`text-primary`} component='span'>
                                                    {obj.Title}
                                                </Typography>
                                            )}
                                        </React.Fragment>
                                    ))} {userPlanDetails === 'loading' &&
                                        <Image
                                            className={`d-inline`}
                                            src={LoadingCustomSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        } قرار دارید.
                                </Typography>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'>
                                <Box>
                                    <Image
                                        src={BadgeSVG}
                                        ms={{
                                            width: '82px'
                                        }} />
                                </Box>
                            </Grid.Item>
                        </React.Fragment>
                    }
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );
};

export default Rank;